import { useAuthContext } from '@contexts/AuthContext/AuthContext';
import { PATHS } from '@routes/paths';
import { Navigate } from 'react-router-dom';

type TProps = {
  children: React.ReactNode;
};

export default function GuestGuard({ children }: TProps) {
  const { iam } = useAuthContext();

  if (iam && iam?.siteRoles.includes('PARTNER')) {
    return <Navigate to={PATHS.main} replace />;
  }

  return <>{children}</>;
}
